"use strict";
/*
 * 配置编译环境和线上环境之间的切换
 * BASE_URL: 域名地址
 */
console.log("NOW_ENV", process.env.NODE_ENV);
let BASE_API = "";
let TRAIL_API = "";
let TEST_HOST_API = "";
let CLOUD_DISK_API = "";
let TUMO_BIND_API= "";
let GLXT_API = "";
let TEST_LOGIN_API = "";
let GNWAY_API_BASE = "";
let GNWAY_SERVER = "";
if (process.env.NODE_ENV === "development") {
  console.log('development--------')
	// 开发环境 测试环境
  // BASE_API = "https://uc-test.pkpm.cn/jsondata";
  // TRAIL_API = "http://9001.dev.ued.pkpm.cn";
  // TEST_HOST_API = "https://api.dev.pkpm.cn/pkpmuser-api";//20230314测试环境采用新的接口地址
  // TEST_LOGIN_API = '/demo'
  // CLOUD_DISK_API = "https://cloud.dev.pkpm.cn";
  // TUMO_BIND_API="https://cloud.dev.pkpm.cn/bimserver/user/v3"
  // GLXT_API="http://116.242.89.226:8104/jsondata"
  // 正式环境,勿删
   BASE_API = "https://ucmanage.pkpm.cn/jsondata"
   TRAIL_API = "https://www.pkpm.cn"
   TEST_HOST_API = "https://uc.api.pkpm.cn/pkpmuser-api"
  TEST_LOGIN_API = '/demo'
  CLOUD_DISK_API = "https://api.cloud.pkpm.cn"
   TUMO_BIND_API="https://api.cloud.pkpm.cn/bimserver/user/v3"
   GLXT_API="https://uc-test.pkpm.cn/jsondata"
  GNWAY_API_BASE = "http://222.249.116.9:8088"
  GNWAY_SERVER = "222.249.116.9:8087"
  //预发布环境,勿删
  // BASE_API = "https://uc-test-rev.pkpm.cn/jsondata";
  // TRAIL_API = "http://9001.dev.ued.pkpm.cn";
  // TEST_HOST_API = "https://uc.api.pkpm.cn:4433/pkpmuser-api";
  // CLOUD_DISK_API = "https://cloud.dev.pkpm.cn";
  // TUMO_BIND_API="https://cloud.dev.pkpm.cn/bimserver/user/v3"
  // GLXT_API="http://116.242.89.226:8104/jsondata"
  //绿建黄区内网
  // BASE_API = "http://192.168.118.135/jsondata";//支付服务、地区、
  // TRAIL_API = "http://9001.dev.ued.pkpm.cn";//官网地址
  // TEST_HOST_API = "http://192.168.118.217:81/pkpmuser-api";
  // TEST_LOGIN_API = 'http://192.168.118.217:81/pkpmuser-api'// 绿箭http不要代理
  // //TEST_LOGIN_API = '/demo' //绿建https 80端口要代理
  // CLOUD_DISK_API = "http://192.168.118.153"
  // TUMO_BIND_API="http://192.168.118.153/bimserver/user/v3"

  //绿建黄区内网https80端口，80端口默认不写
  // BASE_API = "https://192.168.118.135/jsondata";//支付服务、地区、
  // TRAIL_API = "https://116.242.89.226:9001";//官网地址
  // TEST_HOST_API = "https://192.168.118.217/pkpmuser-api";//绿建使用代理demo 2023-05-08
  // TEST_LOGIN_API = '/demo' //2023-05-08
  // CLOUD_DISK_API = "https://192.168.118.153"
  // TUMO_BIND_API="https://192.168.118.153/bimserver/user/v3"

  //绿建内网测试单点登录2 80端口，默认不写
  // BASE_API = "https://192.168.118.221/jsondata";//支付服务、地区、
  // TRAIL_API = "https://116.242.89.226:9001";//官网地址
  // TEST_HOST_API = "https://192.168.118.46/pkpmuser-api";//绿建使用代理demo 2023-05-08
  // TEST_LOGIN_API = '/demo' //2023-05-08
  // CLOUD_DISK_API = "https://192.168.118.153"
  // TUMO_BIND_API="https://192.168.118.153/bimserver/user/v3"

} else if (process.env.NODE_ENV === "production") {
  console.log('production-----')
	//开发环境  测试环境
  // BASE_API = "https://uc-test.pkpm.cn/jsondata";
  // TRAIL_API = "http://9001.dev.ued.pkpm.cn";
  // TEST_HOST_API = "https://api.dev.pkpm.cn/pkpmuser-api";//20230314测试环境采用新的接口地址
  // TEST_LOGIN_API = '/demo'
  // CLOUD_DISK_API = "https://cloud.dev.pkpm.cn";
  // TUMO_BIND_API="https://cloud.dev.pkpm.cn/bimserver/user/v3"
  // GLXT_API="/xet_jsondata"
  // 正式环境,勿删
   BASE_API = "https://ucmanage.pkpm.cn/jsondata"
   TRAIL_API = "https://www.pkpm.cn"
   TEST_HOST_API = "https://uc.api.pkpm.cn/pkpmuser-api"
  TEST_LOGIN_API = '/demo'
   CLOUD_DISK_API = "https://api.cloud.pkpm.cn"
   TUMO_BIND_API="https://api.cloud.pkpm.cn/bimserver/user/v3"
   GLXT_API="/xet_jsondata"
  GNWAY_API_BASE = "http://222.249.116.9:8088"
  GNWAY_SERVER = "222.249.116.9:8087"
  //预发布环境，勿删
  // BASE_API = "https://uc-test-rev.pkpm.cn/jsondata";
  // TRAIL_API = "http://9001.dev.ued.pkpm.cn";
  // TEST_HOST_API = "https://uc.api.pkpm.cn:4433/pkpmuser-api";
  // CLOUD_DISK_API = "https://cloud.dev.pkpm.cn";
  // TUMO_BIND_API="https://cloud.dev.pkpm.cn/bimserver/user/v3"
  // GLXT_API="http://116.242.89.226:8104/jsondata"
  //绿建黄区内网
  //  BASE_API = "http://192.168.118.135/jsondata";//支付服务、地区、
  //  TRAIL_API = "http://9001.dev.ued.pkpm.cn";//官网地址
  //  TEST_HOST_API = "http://192.168.118.217:81/pkpmuser-api";
  //  TEST_LOGIN_API = 'http://192.168.118.217:81/pkpmuser-api'// 绿箭http不要代理
  // //TEST_LOGIN_API = '/demo' // 绿箭使用代理demo 2023-05-08 绿箭https80要代理
  // CLOUD_DISK_API = "http://192.168.118.153"
  //  TUMO_BIND_API="http://192.168.118.153/bimserver/user/v3"
  // GLXT_API="/xet_jsondata"

  //绿建黄区内网https，80端口
  //  BASE_API = "https://192.168.118.135/jsondata";//支付服务、地区、
  //  TRAIL_API = "https://116.242.89.226:9001";//官网地址
  //  TEST_HOST_API = "https://192.168.118.217/pkpmuser-api";
  //  //TEST_LOGIN_API = 'https://192.168.118.217/pkpmuser-api'// 绿箭使用demo 2023-05-08
  // TEST_LOGIN_API = '/demo' // 绿箭使用代理demo 2023-05-08
  // CLOUD_DISK_API = "https://192.168.118.153"
  //  TUMO_BIND_API="https://192.168.118.153/bimserver/user/v3"
  // GLXT_API="/xet_jsondata"

  //绿建内网测试单点登录2 80端口，默认不写
  // BASE_API = "https://192.168.118.221/jsondata";//支付服务、地区、
  // TRAIL_API = "https://116.242.89.226:9001";//官网地址
  // TEST_HOST_API = "https://192.168.118.46/pkpmuser-api";//绿建使用代理demo 2023-05-08
  // TEST_LOGIN_API = '/demo' //2023-05-08
  // CLOUD_DISK_API = "https://192.168.118.153"
  // TUMO_BIND_API="https://192.168.118.153/bimserver/user/v3"

}

//导出
export const BASE_URL = {
  BASE_API,
  TRAIL_API,
  TEST_HOST_API,
  CLOUD_DISK_API,
  TUMO_BIND_API,
  GLXT_API,
  TEST_LOGIN_API,
  GNWAY_API_BASE,
  GNWAY_SERVER
};



//////////////////
// WEBPACK FOOTER
// ./config/env.js
// module id = AMf1
// module chunks = 113